import { useMemo, useState } from "react";
import { FaChild, FaClock, FaLightbulb, FaParking, FaPlus } from "react-icons/fa";
import { getTipKey, getVisitorTips, saveVisitorTip } from "../utils/visitorTips";
import { notifyInfo, notifySuccess } from "../utils/notify";
import "../css/visitorTips.css";

const tipTags = [
  { label: "Best time to visit", icon: FaClock },
  { label: "Parking available", icon: FaParking },
  { label: "Good for kids", icon: FaChild },
];

const VisitorTips = ({ title = "This place", category = "Visitor Tip" }) => {
  const storageKey = useMemo(() => getTipKey({ title, category }), [category, title]);
  const [tips, setTips] = useState(() => getVisitorTips(storageKey));
  const [selectedTag, setSelectedTag] = useState(tipTags[0].label);
  const [message, setMessage] = useState("");

  const submitTip = (event) => {
    event.preventDefault();

    if (message.trim().length < 4) {
      notifyInfo("Please add a short useful tip before submitting.");
      return;
    }

    const nextTips = saveVisitorTip(storageKey, {
      tag: selectedTag,
      message: message.trim(),
    });

    setTips(nextTips);
    setMessage("");
    notifySuccess("Visitor tip added successfully.");
  };

  return (
    <section className="visitor-tips-card">
      <div className="visitor-tips-heading">
        <span>
          <FaLightbulb />
        </span>
        <div>
          <p>Visitor Tips</p>
          <h2>Helpful notes from travellers</h2>
        </div>
      </div>

      <form className="visitor-tip-form" onSubmit={submitTip}>
        <div className="visitor-tip-tags">
          {tipTags.map((tag) => {
            const Icon = tag.icon;

            return (
              <button
                key={tag.label}
                type="button"
                className={selectedTag === tag.label ? "active" : ""}
                onClick={() => setSelectedTag(tag.label)}
              >
                <Icon />
                {tag.label}
              </button>
            );
          })}
        </div>

        <div className="visitor-tip-input-row">
          <input
            value={message}
            maxLength={120}
            placeholder="Share a quick tip..."
            onChange={(event) => setMessage(event.target.value)}
          />
          <button type="submit">
            <FaPlus />
            Add Tip
          </button>
        </div>
      </form>

      <div className="visitor-tip-list">
        {tips.length ? (
          tips.map((tip) => (
            <article key={tip.id}>
              <strong>{tip.tag}</strong>
              <p>{tip.message}</p>
            </article>
          ))
        ) : (
          <p className="visitor-tip-empty">
            No visitor tips yet. Be the first to leave a helpful note.
          </p>
        )}
      </div>
    </section>
  );
};

export default VisitorTips;
